// extracted by mini-css-extract-plugin
export var ol = "styles-module--ol--ZaG5U";
export var ul = "styles-module--ul--qGZBV";
export var hl = "styles-module--hl--BN3zo";
export var h2 = "styles-module--h2--nfNwc";
export var h3 = "styles-module--h3--okCts";
export var h4 = "styles-module--h4--T6ELx";
export var h5 = "styles-module--h5--CyLVX";